/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaCompetitionFormViewProps } from './citta-competition-form';

/**
 *
 * ICittaProductSkuView component
 * @extends {React.PureComponent<ICittaProductSkuViewProps>}
 */
export class ICittaCompetitionFormView extends React.PureComponent<ICittaCompetitionFormViewProps> {

    public render(): JSX.Element | null {
        const { SubscribeWrapper, subscribeResponse, subscribeForm, responseSuccess, showResponseSuccess, formErrors, formErrorsNodeProps, successResponseNodeProps, showSuccessResponse, successResponse } = this.props;
        const { 
            FormWrapper,
            FormContainer,
            firstAndLastNameInput,
            emailInput,
            countryInput,
            additionalTextInput,
            checkboxTermsAndConditions,
            checkboxPrivacyPolicy,
            subscribeButtton,
            reCaptcha,
            subscribeThanks
        } = subscribeForm;
        return (
            <Module {...SubscribeWrapper} >
                {subscribeResponse}
                {showSuccessResponse ?
                    <Node {...successResponseNodeProps}>
                        {successResponse}
                    </Node>
                    : <Node {...FormWrapper} >
                        <Node {...FormContainer} >
                            {firstAndLastNameInput}
                            {emailInput}
                            {additionalTextInput}
                            {countryInput}
                            {checkboxTermsAndConditions}
                            {checkboxPrivacyPolicy}
                            {reCaptcha}
                            {responseSuccess && showResponseSuccess ? subscribeThanks : subscribeButtton}
                        </Node>
                        <Node {...formErrorsNodeProps}>
                            {formErrors}
                        </Node>
                    </Node>
                }
            </Module>
        );
    }
}
export default ICittaCompetitionFormView;
